import { atom, useRecoilState } from 'recoil';

import { VideoQuality } from '/lib/getIntendedQuality';

const videoQualityState = atom<VideoQuality>({
  key: 'video-quality',
  default: 'auto',
});

export const useVideoQuality = () => {
  const [videoQuality, setVideoQuality] = useRecoilState(videoQualityState);

  return {
    videoQuality,
    setVideoQuality,
  };
};
